import { Box } from '@mui/system'
import PropTypes from 'prop-types'

import hapanaSparkIcon from '@hapana/shared/web/styles/assets/images/hapana-spark-icon.png'

import { styles } from './hapana-spark-loading.styles'

const HapanaSparkLoading = ({ size }) => (
  <Box
    component="img"
    src={hapanaSparkIcon}
    sx={size ? { ...styles.loading, height: size, width: size } : styles.loading}
    alt="Hapana Spark"
  />
)

HapanaSparkLoading.propTypes = {
  size: PropTypes.number,
}

export default HapanaSparkLoading
